import {Component , EventEmitter , Input , OnChanges , OnInit , Output} from '@angular/core';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {TranslateService} from '@ngx-translate/core';
import html2canvas from 'html2canvas';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {FuncionTypeService} from '../../../../../core/services/functionType.service';
import {OrganizationsService} from '../../../../../core/services/organizations.service';
import {ChartsModule} from 'angular-bootstrap-md';

@Component({
    selector: 'estimation-component',
    templateUrl: './estimation-component.html',
    styleUrls: ['./estimation-component.scss'],
    providers: [{
            provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
        }],
    standalone: true,
  imports: [MaterialModule, SharedModule, ChartsModule]
})

export class EstimationTabComponent implements OnInit , OnChanges {
  @Input() eventData;
  @Input() country;
  @Input() organization;
  @Input() participantNumber = 0;
  @Input() participantFriendCount = 0;
  @Input() cost;
  @Input() costFriend;
  @Output() estimationTabData = new EventEmitter();
  functionType = [];
  totalResult = 0;
  budgetData;
  times = {
    'preparation': {} ,
    'execution': {} ,
    'follow-up': {} ,

  };
  adminRates = {};
  rateResult = {};


  public chartType2 = 'pie';

  public chartDatasets2: Array<any> = [
    {
      data: [] , label: 'Budget'
    }
  ];

  public chartLabels2: Array<any> = [ 'material' , 'meals' , 'transport ' , 'rents' , 'miscellaneous' ];

  public chartColors2: Array<any> = [
    {
      backgroundColor: [ '#F7464A' , '#46BFBD' , '#FDB45C' , '#949FB1' , '#4D5360' ] ,
      hoverBackgroundColor: [ '#FF5A5E' , '#5AD3D1' , '#FFC870' , '#A8B3C5' , '#616774' ] ,
      borderWidth: 2 ,
    }
  ];

  public chartOptions2: any = {
    responsive: true
  };


  public chartType = 'bar';

  public chartDatasets: Array<any> = [
    {
      data: [] , label: 'preparation'
    } ,
    {
      data: [] , label: 'execution'
    },
    {
      data: [] , label: 'follow-up'
    } ,

  ];

  public chartDatasets1: Array<any> = [
    {
      data: [] , label: 'preparation'
    } ,
    {
      data: [] , label: 'execution'
    },
    {
      data: [] , label: 'follow-up'
    } ,

  ];


  public chartLabels: Array<any> = [];

  public chartColors: Array<any> = [
    {
      backgroundColor: [
        'rgba(255,255,102, 0.2)' ,
        'rgba(255,255,102, 0.2)' ,
        'rgba(255,255,102, 0.2)' ,
        'rgba(255,255,102, 0.2)' ,
        'rgba(255,255,102, 0.2)' ,
        'rgba(255,255,102, 0.2)' ,
      ] ,
    } ,
    {
      backgroundColor: [
        'rgba(51,153,51, 0.2)' ,
        'rgba(51,153,51, 0.2)' ,
        'rgba(51,153,51, 0.2)' ,
        'rgba(51,153,51, 0.2)' ,
        'rgba(51,153,51, 0.2)' ,
        'rgba(51,153,51, 0.2)' ,
      ] ,
    } ,
    {
      backgroundColor: [
        'rgba(0,102,255, 0.2)' ,
        'rgba(0,102,255, 0.2)' ,
        'rgba(0,102,255, 0.2)' ,
        'rgba(0,102,255, 0.2)' ,
        'rgba(0,102,255, 0.2)' ,
      ] ,
    }
  ];

  totalResultFriend = 0;
  totalBudget = 0;
  currency = 'CHF/EUR';
  totalTime = 0;
  translateArray = [ 'budget.material' , 'budget.meals' , 'budget.transport' , 'budget.rents' , 'budget.miscellaneous' ,
                     'budget.preparation' , 'budget.follow-up' , 'budget.execution' , 'budget.totalCoastIn' , 'budget.totalTimeIn' , 'budget.hourText' ];
  translateArrayBudget = [ 'budget.totalBudgetIn' ];
  public chartOptions: any = {
    responsive: true ,
    title: {
      display: true ,
      text: 'Total costs in ' + this.currency
    } ,
  };
  public chartOptions1: any = {
    responsive: true ,
    title: {
      display: true ,
      text: 'Total time in h'
    } ,
  };
  hourText = 'h';
  totalBudgetText = ' ';
  adminTypesId = [];
  locale = 'en';
  adminResultData = [];
  budgetCost = 0;
  constructor (private functionTypeService: FuncionTypeService ,
               private organizationService: OrganizationsService ,
               public translate: TranslateService) {
    this.functionTypeService.getFunctionTypeDropDown().subscribe((res: any) => {
      this.functionType = res;
      if (!this.eventData || !this.eventData.estTimes) {
        for (let i = 0; i < res.length; i++) {
          this.times[ 'preparation' ][ res[ i ].id ] = 0;
          this.times[ 'execution' ][ res[ i ].id ] = 0;
          this.times[ 'follow-up' ][ res[ i ].id ] = 0;

        }
      }
    });
    this.translate.stream(this.translateArrayBudget).subscribe((res: any) => {
      this.totalBudgetText = res[ 'budget.totalBudgetIn' ];
    });
    translate.stream(this.translateArray).subscribe((res: any) => {
      this.chartLabels2 = [];
      this.chartLabels2.push(res[ 'budget.material' ]);
      this.chartLabels2.push(res[ 'budget.meals' ]);
      this.chartLabels2.push(res[ 'budget.transport' ]);
      this.chartLabels2.push(res[ 'budget.rents' ]);
      this.chartLabels2.push(res[ 'budget.miscellaneous' ]);
      this.chartDatasets[ 0 ].label = res[ 'budget.preparation' ];
      this.chartDatasets1[ 0 ].label = res[ 'budget.preparation' ];
      this.chartDatasets[ 2 ].label = res[ 'budget.follow-up' ];
      this.chartDatasets1[ 2 ].label = res[ 'budget.follow-up' ];
      this.chartDatasets[ 1 ].label = res[ 'budget.execution' ];
      this.chartDatasets1[ 1 ].label = res[ 'budget.execution' ];
      this.chartOptions1.title.text = res[ 'budget.totalTimeIn' ];
      this.chartOptions.title.text = res[ 'budget.totalCoastIn' ] + ' ' + this.currency;
      this.hourText = res[ 'budget.hourText' ];
    });
    translate.onLangChange.subscribe((res) => {
      this.locale = res.lang;
    });
  }

  ngOnInit () {
    this.initForm();
  }

  ngOnChanges (e) {
    if (this.eventData) {
      this.initForm();
      if (this.eventData) {
        let jsonTimes: any = {};
        if (!jsonTimes[ 'preparation' ]) {
          jsonTimes[ 'preparation' ] = {
            0: this.eventData.preparationMin,
            1: this.eventData.preparationMax,
          };
        }
        if (!jsonTimes[ 'follow-up' ]) {
          jsonTimes[ 'follow-up' ] = {
            0: this.eventData.followUpMin,
            1: this.eventData.followUpMax,
          };
        }
        if (!jsonTimes[ 'execution' ]) {
          jsonTimes[ 'execution' ] = {
            0: this.eventData.executionMin,
            1: this.eventData.executionMax,
          };
        }
        this.times = jsonTimes;
      }
    }
    if (this.country === 'DE' || this.country === 'AU') {
      this.currency = 'EUR';
    }
    if (this.country === 'CH') {
      this.currency = 'CHF';
    }

    if (this.organization) {
      this.organizationService.getAdminRates(this.organization).subscribe((res: any) => {
        this.adminRates = {};
        for (let i = 0; i < res.length; i++) {
          if (!this.adminRates[ res[ i ].type ]) {
            this.adminRates[ res[ i ].type ] = {};
          }
          this.adminRates[ res[ i ].type ][ res[ i ].functionId ] = res[ i ].rate;
        }
        this.calculateRates();
      });
      this.organizationService.getAdminType(this.organization).subscribe((res: any) => {
        this.adminTypesId = res;
        this.calculateRates();
      });
    }
    if (this.cost && this.participantNumber) {
      this.totalResult = this.cost * this.participantNumber;
    }
    if (this.costFriend && this.participantNumber) {
      this.totalResultFriend = this.cost * this.participantFriendCount;
    }
  }

  calculateRates () {
    this.rateResult = {preparation: [] , 'follow-up': [] , execution: []};
    this.chartDatasets[ 0 ].data = [];
    this.chartDatasets1[ 0 ].data = [];
    this.chartDatasets[ 2 ].data = [];
    this.chartDatasets1[ 2 ].data = [];
    this.chartDatasets[ 1 ].data = [];
    this.chartDatasets1[ 1 ].data = [];
    this.chartLabels = [];
    this.totalTime = 0;
    this.totalResult = this.cost * this.participantNumber;
    this.totalResultFriend = this.costFriend * this.participantFriendCount;
    this.prepareRateObj('preparation' , 0);
    this.prepareRateObj('follow-up' , 2);
    this.prepareRateObj('execution' , 1);
    // console.log(this.rateResult);
    if (this.rateResult) {
      this.adminResultData = [];
      if (this.rateResult['preparation']) {
        for (let i = 0; i < this.rateResult['preparation'].length; i++) {
          const index = this.adminResultData.findIndex(x => x.name === this.rateResult['preparation'][i].name);
          // console.log(index);
          if (index === -1) {
            this.adminResultData.push({name: this.rateResult['preparation'][i].name, hour: this.rateResult['preparation'][i].hourData, rate: this.rateResult['preparation'][i].hourData * this.rateResult['preparation'][i].rateData});
          } else {
            this.adminResultData[index].hour =  this.adminResultData[index].hour + this.rateResult['preparation'][i].hourData;
            this.adminResultData[index].rate =  this.adminResultData[index].rate + (this.rateResult['preparation'][i].hourData * this.rateResult['preparation'][i].rateData);
          }
        }
      }
      if (this.rateResult['follow-up']) {
        for (let i = 0; i < this.rateResult['follow-up'].length; i++) {
          const index = this.adminResultData.findIndex(x => x.name === this.rateResult['follow-up'][i].name);
          // console.log(index);
          if (index === -1) {
            this.adminResultData.push({name: this.rateResult['follow-up'][i].name, hour: this.rateResult['follow-up'][i].hourData, rate: this.rateResult['follow-up'][i].hourData * this.rateResult['follow-up'][i].rateData});
          } else {
            this.adminResultData[index].hour =  this.adminResultData[index].hour + this.rateResult['follow-up'][i].hourData;
            this.adminResultData[index].rate =  this.adminResultData[index].rate + (this.rateResult['follow-up'][i].hourData * this.rateResult['follow-up'][i].rateData);
          }
        }
      }
      if (this.rateResult['execution']) {
        for (let i = 0; i < this.rateResult['execution'].length; i++) {
          const index = this.adminResultData.findIndex(x => x.name === this.rateResult['execution'][i].name);
          // console.log(index);
          if (index === -1) {
            this.adminResultData.push({name: this.rateResult['execution'][i].name, hour: this.rateResult['execution'][i].hourData, rate: this.rateResult['execution'][i].hourData * this.rateResult['execution'][i].rateData});
          } else {
            this.adminResultData[index].hour =  this.adminResultData[index].hour + this.rateResult['execution'][i].hourData;
            this.adminResultData[index].rate =  this.adminResultData[index].rate + (this.rateResult['execution'][i].hourData * this.rateResult['execution'][i].rateData);
          }
        }
      }
    }
    if (this.adminResultData.length) {
      this.budgetCost = 0;
      this.adminResultData.forEach(el => {
        this.budgetCost = this.budgetCost + +el.rate;
      });
      this.budgetCost = this.budgetCost + +this.totalBudget;
    }
  }

  prepareRateObj (keyInfo , index) {
    const followUpKeys = Object.keys(this.times[ keyInfo ]);
    for (const key of followUpKeys) {
      for (let j = 0; j < this.functionType.length; j++) {
        if (parseInt(key , 10) === this.functionType[ j ].id) {
          if (index === 0 && this.adminTypesId.includes(this.functionType[ j ].id)) {
            this.chartLabels.push(this.functionType[ j ].name);
          }

          if (this.adminTypesId.includes(this.functionType[ j ].id)) {
            if (this.adminRates[ keyInfo ] && this.adminRates[ keyInfo ][ key ]) {
              this.rateResult[ keyInfo ].push({
                hour: (this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ) + ' ' + this.hourText ,
                rate: this.currency + ' ' + this.adminRates[ keyInfo ][ key ] + ' .-' ,
                data: this.currency + ' ' + parseInt(this.adminRates[ keyInfo ][ key ] , 10) * parseInt((this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ), 10) + ' .-' ,
                name: this.functionType[ j ].name,
                hourData: (this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ),
                rateData: parseInt((this.adminRates[ keyInfo ][ key ] ? this.adminRates[ keyInfo ][ key ] : 0 ), 10)
              });
              this.chartDatasets[ index ][ 'data' ].push(parseInt(this.adminRates[ keyInfo ][ key ] , 10) * parseInt((this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ) , 10));
              this.totalResult = this.totalResult - (parseInt(this.adminRates[ keyInfo ][ key ] , 10) * parseInt((this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ) , 10));
              this.chartDatasets1[ index ][ 'data' ].push(parseInt((this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ), 10));
              this.totalTime = this.totalTime + parseInt((this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ) , 10);
            } else {
              this.rateResult[ keyInfo ].push({
                hour: (this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ) + ' ' + this.hourText ,
                rate: 'n/i' ,
                data: 'n/i' ,
                name: this.functionType[ j ].name,
                hourData: (this.times[ keyInfo ][ key ] ? this.times[ keyInfo ][ key ] : 0 ),
                rateData: 0
              });
              this.chartDatasets[ index ][ 'data' ].push(0);
              this.chartDatasets1[ index ][ 'data' ].push(parseInt(this.times[ keyInfo ][ key ] , 10));
            }
          }
        }
      }
    }
  }

  initForm () {
    if (this.eventData) {
      this.setBudgetDonut(this.eventData);
    }
  }

  setBudgetDonut (data) {
    this.budgetData = data;
    this.chartDatasets2[ 0 ].data = [];
    this.chartDatasets2[ 0 ].data.push(data.material);
    this.chartDatasets2[ 0 ].data.push(data.meals);
    this.chartDatasets2[ 0 ].data.push(data.transport);
    this.chartDatasets2[ 0 ].data.push(data.miscellaneous);
    this.chartDatasets2[ 0 ].data.push(data.rents);
    this.totalBudget = data.material + data.meals + data.transport + data.miscellaneous + data.rents;
    this.chartOptions2 = {
      responsive: true ,
      title: {
        display: true ,
        text: this.totalBudgetText + ' ' + this.currency + ' ' + this.totalBudget + '.-'
      } ,
    };
  }

  public chartClicked (e: any): void {
  }

  public chartHovered (e: any): void {
  }

  printDiagram(id) {
    html2canvas(document.getElementById(id)).then(canvas => {
      let nWindow = window.open('');

      // append the canvas to the body
      nWindow.document.body.appendChild(canvas);

      // focus on the window
      nWindow.focus();

      // print the window
      nWindow.print();
    });
  }
}
